// Types
import mixins from"vue-typed-mixins";// Components
import{CookieElement}from"../../overridableComponents";// Mixins
import EditorContainer from"../../../mixins/EditorContainer";import LayoutElementProvider from"../../../mixins/LayoutElementProvide";// Enums
import{StaticElements}from"../../../enums/StaticElements";// Main
const CookieContainer=mixins(EditorContainer,LayoutElementProvider(StaticElements.Cookie)).extend({name:"CookieContainer",render(){const a=arguments[0];return a(CookieElement)}});export default CookieContainer;